import { useOrgStore } from '@/stores/org-store';
import { apiRequest } from '@/utils/api-request';

interface SendInviteProps {
  email: string;
  role?: string;
  canChooseRole?: boolean;
  organizationId?: string | null;
}

interface SendInviteResponse {
  data?: {
    code: 'invitation-sent';
  };
  detail?: string;
}

interface BodyProps extends Record<string, unknown> {
  email: string;
  role?: string;
  origin?: string;
}

export const sendInvite = async ({
  email,
  role,
  canChooseRole,
  organizationId,
}: SendInviteProps): Promise<SendInviteResponse> => {
  const orgId = organizationId || useOrgStore.getState().currentOrg?.orgid;

  const body: BodyProps = {
    email: email.toLowerCase(),
  };

  if (canChooseRole) {
    body.role = role;
  }

  const result = await apiRequest({
    url: `/org-members/${orgId}/invites`,
    target: 'platform',
    method: 'POST',
    body,
  });

  if (result?.detail) {
    return {
      detail: result.detail,
    };
  }

  return result as SendInviteResponse;
};
